import { render, staticRenderFns } from "./serviceManagement.vue?vue&type=template&id=517db87e&scoped=true&"
import script from "./serviceManagement.vue?vue&type=script&lang=js&"
export * from "./serviceManagement.vue?vue&type=script&lang=js&"
import style0 from "./serviceManagement.vue?vue&type=style&index=0&id=517db87e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517db87e",
  null
  
)

export default component.exports